export const SBP_MIN_AMOUNT_RUBLES = 500;
export const WALLET_TOPUP_POLL_MS = 2000;
export const WALLET_TOPUP_ID_QUERY = 'topupId';

export const WALLET_TOPUP_PAYMENT_METHODS = ['SBP', 'CARD'] as const;

export const SBP_PAY_TEST_STATUSES = ['CONFIRMED', 'REJECTED', 'EXPIRED'] as const;

export const SBP_PAY_TEST_STATUS_OPTIONS = [
  { value: 'CONFIRMED', label: 'CONFIRMED' },
  { value: 'REJECTED', label: 'REJECTED' },
  { value: 'EXPIRED', label: 'EXPIRED' },
] as const;
